export type IconsId =
  | 'abv'
  | 'add'
  | 'advanced-notes'
  | 'alcohol'
  | 'alert-circle-filled'
  | 'alert-circle'
  | 'alert-triangle'
  | 'amex'
  | 'app-subscription'
  | 'apple-pay'
  | 'armoa'
  | 'arrow-left'
  | 'award-winning'
  | 'award'
  | 'back'
  | 'biodynamic'
  | 'birthday-bonus'
  | 'blend-type'
  | 'bottle-glass'
  | 'bottle'
  | 'boxes'
  | 'calendar-clock'
  | 'calendar'
  | 'camera'
  | 'caps-lock'
  | 'cart'
  | 'case'
  | 'check'
  | 'Checkbox'
  | 'cheers'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'chocolate'
  | 'choice-check'
  | 'choice-uncheck'
  | 'circle-chevron-left'
  | 'circle-chevron-right'
  | 'circle-filled'
  | 'clear-circle'
  | 'close'
  | 'convenient-delivery'
  | 'cork-screw'
  | 'coupons'
  | 'credit-card'
  | 'customer-services'
  | 'customize'
  | 'customized-selections'
  | 'delete'
  | 'diamond'
  | 'discover'
  | 'dot-menu'
  | 'dots-menu'
  | 'droplet'
  | 'edit'
  | 'email'
  | 'envelope-box'
  | 'envelope'
  | 'expand'
  | 'eye'
  | 'facebook'
  | 'file-user'
  | 'filter'
  | 'flexibility'
  | 'free-delivery'
  | 'gift'
  | 'glass'
  | 'glasses'
  | 'google-pay'
  | 'grape'
  | 'green-tick'
  | 'hamburger-menu'
  | 'hand-truck'
  | 'heart-solid'
  | 'heart'
  | 'help-circle'
  | 'hide-password'
  | 'home'
  | 'homepage-customisation'
  | 'info-circle'
  | 'information-circle'
  | 'instagram'
  | 'kosher'
  | 'label-scanner'
  | 'last-sold-bg'
  | 'ligntning-solid'
  | 'linked-in'
  | 'live-chat'
  | 'location-dotted'
  | 'location'
  | 'mastercard'
  | 'menu'
  | 'minus'
  | 'money-back-apac'
  | 'money-back-us'
  | 'money-back'
  | 'mute'
  | 'no-obligation'
  | 'offset-carbon'
  | 'organic'
  | 'packaging-pioneer'
  | 'pad-lock-benefits'
  | 'padlock'
  | 'pause'
  | 'paypal'
  | 'phone-arrow'
  | 'phone-solid'
  | 'phone'
  | 'pioneer'
  | 'placeholder'
  | 'play-video'
  | 'play'
  | 'print'
  | 'question-circle'
  | 'radio-selected'
  | 'radio'
  | 'red-alert-circle-filled'
  | 'restaurant-dishes'
  | 'rossette'
  | 'sale-tag-benefits'
  | 'sale-tag'
  | 'sale'
  | 'satisfaction-guarantee'
  | 'saving'
  | 'savings'
  | 'search'
  | 'share'
  | 'sort'
  | 'star-solid'
  | 'star'
  | 'stwc-blog'
  | 'subscribe-save'
  | 'sustainable'
  | 'target'
  | 'thumbs-down-solid'
  | 'thumbs-down'
  | 'thumbs-up-solid'
  | 'thumbs-up'
  | 'tick-circle-solid'
  | 'tick-circle'
  | 'ticket'
  | 'trending'
  | 'truck-benefits'
  | 'truck-solid'
  | 'truck'
  | 'trust'
  | 'twitter'
  | 'unidentified-country'
  | 'units'
  | 'unlimited-avr'
  | 'unlimited-sale'
  | 'unlimited-save'
  | 'unlimited-stwc'
  | 'unlimited-truck'
  | 'unlimited'
  | 'unltCheckIcon'
  | 'user'
  | 'vegan'
  | 'vegetarian'
  | 'views'
  | 'vinny'
  | 'visa'
  | 'warning'
  | 'wine-colour'
  | 'wine-glass'
  | 'world'
  | 'x-twitter'
  | 'youtube'
  | 'zoom';

export type IconsKey =
  | 'Abv'
  | 'Add'
  | 'AdvancedNotes'
  | 'Alcohol'
  | 'AlertCircleFilled'
  | 'AlertCircle'
  | 'AlertTriangle'
  | 'Amex'
  | 'AppSubscription'
  | 'ApplePay'
  | 'Armoa'
  | 'ArrowLeft'
  | 'AwardWinning'
  | 'Award'
  | 'Back'
  | 'Biodynamic'
  | 'BirthdayBonus'
  | 'BlendType'
  | 'BottleGlass'
  | 'Bottle'
  | 'Boxes'
  | 'CalendarClock'
  | 'Calendar'
  | 'Camera'
  | 'CapsLock'
  | 'Cart'
  | 'Case'
  | 'Check'
  | 'Checkbox'
  | 'Cheers'
  | 'ChevronDown'
  | 'ChevronLeft'
  | 'ChevronRight'
  | 'ChevronUp'
  | 'Chocolate'
  | 'ChoiceCheck'
  | 'ChoiceUncheck'
  | 'CircleChevronLeft'
  | 'CircleChevronRight'
  | 'CircleFilled'
  | 'ClearCircle'
  | 'Close'
  | 'ConvenientDelivery'
  | 'CorkScrew'
  | 'Coupons'
  | 'CreditCard'
  | 'CustomerServices'
  | 'Customize'
  | 'CustomizedSelections'
  | 'Delete'
  | 'Diamond'
  | 'Discover'
  | 'DotMenu'
  | 'DotsMenu'
  | 'Droplet'
  | 'Edit'
  | 'Email'
  | 'EnvelopeBox'
  | 'Envelope'
  | 'Expand'
  | 'Eye'
  | 'Facebook'
  | 'FileUser'
  | 'Filter'
  | 'Flexibility'
  | 'FreeDelivery'
  | 'Gift'
  | 'Glass'
  | 'Glasses'
  | 'GooglePay'
  | 'Grape'
  | 'GreenTick'
  | 'HamburgerMenu'
  | 'HandTruck'
  | 'HeartSolid'
  | 'Heart'
  | 'HelpCircle'
  | 'HidePassword'
  | 'Home'
  | 'HomepageCustomisation'
  | 'InfoCircle'
  | 'InformationCircle'
  | 'Instagram'
  | 'Kosher'
  | 'LabelScanner'
  | 'LastSoldBg'
  | 'LigntningSolid'
  | 'LinkedIn'
  | 'LiveChat'
  | 'LocationDotted'
  | 'Location'
  | 'Mastercard'
  | 'Menu'
  | 'Minus'
  | 'MoneyBackApac'
  | 'MoneyBackUs'
  | 'MoneyBack'
  | 'Mute'
  | 'NoObligation'
  | 'OffsetCarbon'
  | 'Organic'
  | 'PackagingPioneer'
  | 'PadLockBenefits'
  | 'Padlock'
  | 'Pause'
  | 'Paypal'
  | 'PhoneArrow'
  | 'PhoneSolid'
  | 'Phone'
  | 'Pioneer'
  | 'Placeholder'
  | 'PlayVideo'
  | 'Play'
  | 'Print'
  | 'QuestionCircle'
  | 'RadioSelected'
  | 'Radio'
  | 'RedAlertCircleFilled'
  | 'RestaurantDishes'
  | 'Rossette'
  | 'SaleTagBenefits'
  | 'SaleTag'
  | 'Sale'
  | 'SatisfactionGuarantee'
  | 'Saving'
  | 'Savings'
  | 'Search'
  | 'Share'
  | 'Sort'
  | 'StarSolid'
  | 'Star'
  | 'StwcBlog'
  | 'SubscribeSave'
  | 'Sustainable'
  | 'Target'
  | 'ThumbsDownSolid'
  | 'ThumbsDown'
  | 'ThumbsUpSolid'
  | 'ThumbsUp'
  | 'TickCircleSolid'
  | 'TickCircle'
  | 'Ticket'
  | 'Trending'
  | 'TruckBenefits'
  | 'TruckSolid'
  | 'Truck'
  | 'Trust'
  | 'Twitter'
  | 'UnidentifiedCountry'
  | 'Units'
  | 'UnlimitedAvr'
  | 'UnlimitedSale'
  | 'UnlimitedSave'
  | 'UnlimitedStwc'
  | 'UnlimitedTruck'
  | 'Unlimited'
  | 'UnltCheckIcon'
  | 'User'
  | 'Vegan'
  | 'Vegetarian'
  | 'Views'
  | 'Vinny'
  | 'Visa'
  | 'Warning'
  | 'WineColour'
  | 'WineGlass'
  | 'World'
  | 'XTwitter'
  | 'Youtube'
  | 'Zoom';

export enum Icons {
  Abv = 'abv',
  Add = 'add',
  AdvancedNotes = 'advanced-notes',
  Alcohol = 'alcohol',
  AlertCircleFilled = 'alert-circle-filled',
  AlertCircle = 'alert-circle',
  AlertTriangle = 'alert-triangle',
  Amex = 'amex',
  AppSubscription = 'app-subscription',
  ApplePay = 'apple-pay',
  Armoa = 'armoa',
  ArrowLeft = 'arrow-left',
  AwardWinning = 'award-winning',
  Award = 'award',
  Back = 'back',
  Biodynamic = 'biodynamic',
  BirthdayBonus = 'birthday-bonus',
  BlendType = 'blend-type',
  BottleGlass = 'bottle-glass',
  Bottle = 'bottle',
  Boxes = 'boxes',
  CalendarClock = 'calendar-clock',
  Calendar = 'calendar',
  Camera = 'camera',
  CapsLock = 'caps-lock',
  Cart = 'cart',
  Case = 'case',
  Check = 'check',
  Checkbox = 'Checkbox',
  Cheers = 'cheers',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Chocolate = 'chocolate',
  ChoiceCheck = 'choice-check',
  ChoiceUncheck = 'choice-uncheck',
  CircleChevronLeft = 'circle-chevron-left',
  CircleChevronRight = 'circle-chevron-right',
  CircleFilled = 'circle-filled',
  ClearCircle = 'clear-circle',
  Close = 'close',
  ConvenientDelivery = 'convenient-delivery',
  CorkScrew = 'cork-screw',
  Coupons = 'coupons',
  CreditCard = 'credit-card',
  CustomerServices = 'customer-services',
  Customize = 'customize',
  CustomizedSelections = 'customized-selections',
  Delete = 'delete',
  Diamond = 'diamond',
  Discover = 'discover',
  DotMenu = 'dot-menu',
  DotsMenu = 'dots-menu',
  Droplet = 'droplet',
  Edit = 'edit',
  Email = 'email',
  EnvelopeBox = 'envelope-box',
  Envelope = 'envelope',
  Expand = 'expand',
  Eye = 'eye',
  Facebook = 'facebook',
  FileUser = 'file-user',
  Filter = 'filter',
  Flexibility = 'flexibility',
  FreeDelivery = 'free-delivery',
  Gift = 'gift',
  Glass = 'glass',
  Glasses = 'glasses',
  GooglePay = 'google-pay',
  Grape = 'grape',
  GreenTick = 'green-tick',
  HamburgerMenu = 'hamburger-menu',
  HandTruck = 'hand-truck',
  HeartSolid = 'heart-solid',
  Heart = 'heart',
  HelpCircle = 'help-circle',
  HidePassword = 'hide-password',
  Home = 'home',
  HomepageCustomisation = 'homepage-customisation',
  InfoCircle = 'info-circle',
  InformationCircle = 'information-circle',
  Instagram = 'instagram',
  Kosher = 'kosher',
  LabelScanner = 'label-scanner',
  LastSoldBg = 'last-sold-bg',
  LigntningSolid = 'ligntning-solid',
  LinkedIn = 'linked-in',
  LiveChat = 'live-chat',
  LocationDotted = 'location-dotted',
  Location = 'location',
  Mastercard = 'mastercard',
  Menu = 'menu',
  Minus = 'minus',
  MoneyBackApac = 'money-back-apac',
  MoneyBackUs = 'money-back-us',
  MoneyBack = 'money-back',
  Mute = 'mute',
  NoObligation = 'no-obligation',
  OffsetCarbon = 'offset-carbon',
  Organic = 'organic',
  PackagingPioneer = 'packaging-pioneer',
  PadLockBenefits = 'pad-lock-benefits',
  Padlock = 'padlock',
  Pause = 'pause',
  Paypal = 'paypal',
  PhoneArrow = 'phone-arrow',
  PhoneSolid = 'phone-solid',
  Phone = 'phone',
  Pioneer = 'pioneer',
  Placeholder = 'placeholder',
  PlayVideo = 'play-video',
  Play = 'play',
  Print = 'print',
  QuestionCircle = 'question-circle',
  RadioSelected = 'radio-selected',
  Radio = 'radio',
  RedAlertCircleFilled = 'red-alert-circle-filled',
  RestaurantDishes = 'restaurant-dishes',
  Rossette = 'rossette',
  SaleTagBenefits = 'sale-tag-benefits',
  SaleTag = 'sale-tag',
  Sale = 'sale',
  SatisfactionGuarantee = 'satisfaction-guarantee',
  Saving = 'saving',
  Savings = 'savings',
  Search = 'search',
  Share = 'share',
  Sort = 'sort',
  StarSolid = 'star-solid',
  Star = 'star',
  StwcBlog = 'stwc-blog',
  SubscribeSave = 'subscribe-save',
  Sustainable = 'sustainable',
  Target = 'target',
  ThumbsDownSolid = 'thumbs-down-solid',
  ThumbsDown = 'thumbs-down',
  ThumbsUpSolid = 'thumbs-up-solid',
  ThumbsUp = 'thumbs-up',
  TickCircleSolid = 'tick-circle-solid',
  TickCircle = 'tick-circle',
  Ticket = 'ticket',
  Trending = 'trending',
  TruckBenefits = 'truck-benefits',
  TruckSolid = 'truck-solid',
  Truck = 'truck',
  Trust = 'trust',
  Twitter = 'twitter',
  UnidentifiedCountry = 'unidentified-country',
  Units = 'units',
  UnlimitedAvr = 'unlimited-avr',
  UnlimitedSale = 'unlimited-sale',
  UnlimitedSave = 'unlimited-save',
  UnlimitedStwc = 'unlimited-stwc',
  UnlimitedTruck = 'unlimited-truck',
  Unlimited = 'unlimited',
  UnltCheckIcon = 'unltCheckIcon',
  User = 'user',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
  Views = 'views',
  Vinny = 'vinny',
  Visa = 'visa',
  Warning = 'warning',
  WineColour = 'wine-colour',
  WineGlass = 'wine-glass',
  World = 'world',
  XTwitter = 'x-twitter',
  Youtube = 'youtube',
  Zoom = 'zoom',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Abv]: '61697',
  [Icons.Add]: '61698',
  [Icons.AdvancedNotes]: '61699',
  [Icons.Alcohol]: '61700',
  [Icons.AlertCircleFilled]: '61701',
  [Icons.AlertCircle]: '61702',
  [Icons.AlertTriangle]: '61703',
  [Icons.Amex]: '61704',
  [Icons.AppSubscription]: '61705',
  [Icons.ApplePay]: '61706',
  [Icons.Armoa]: '61707',
  [Icons.ArrowLeft]: '61708',
  [Icons.AwardWinning]: '61709',
  [Icons.Award]: '61710',
  [Icons.Back]: '61711',
  [Icons.Biodynamic]: '61712',
  [Icons.BirthdayBonus]: '61713',
  [Icons.BlendType]: '61714',
  [Icons.BottleGlass]: '61715',
  [Icons.Bottle]: '61716',
  [Icons.Boxes]: '61717',
  [Icons.CalendarClock]: '61718',
  [Icons.Calendar]: '61719',
  [Icons.Camera]: '61720',
  [Icons.CapsLock]: '61721',
  [Icons.Cart]: '61722',
  [Icons.Case]: '61723',
  [Icons.Check]: '61724',
  [Icons.Checkbox]: '61725',
  [Icons.Cheers]: '61726',
  [Icons.ChevronDown]: '61727',
  [Icons.ChevronLeft]: '61728',
  [Icons.ChevronRight]: '61729',
  [Icons.ChevronUp]: '61730',
  [Icons.Chocolate]: '61731',
  [Icons.ChoiceCheck]: '61732',
  [Icons.ChoiceUncheck]: '61733',
  [Icons.CircleChevronLeft]: '61734',
  [Icons.CircleChevronRight]: '61735',
  [Icons.CircleFilled]: '61736',
  [Icons.ClearCircle]: '61737',
  [Icons.Close]: '61738',
  [Icons.ConvenientDelivery]: '61739',
  [Icons.CorkScrew]: '61740',
  [Icons.Coupons]: '61741',
  [Icons.CreditCard]: '61742',
  [Icons.CustomerServices]: '61743',
  [Icons.Customize]: '61744',
  [Icons.CustomizedSelections]: '61745',
  [Icons.Delete]: '61746',
  [Icons.Diamond]: '61747',
  [Icons.Discover]: '61748',
  [Icons.DotMenu]: '61749',
  [Icons.DotsMenu]: '61750',
  [Icons.Droplet]: '61751',
  [Icons.Edit]: '61752',
  [Icons.Email]: '61753',
  [Icons.EnvelopeBox]: '61754',
  [Icons.Envelope]: '61755',
  [Icons.Expand]: '61756',
  [Icons.Eye]: '61757',
  [Icons.Facebook]: '61758',
  [Icons.FileUser]: '61759',
  [Icons.Filter]: '61760',
  [Icons.Flexibility]: '61761',
  [Icons.FreeDelivery]: '61762',
  [Icons.Gift]: '61763',
  [Icons.Glass]: '61764',
  [Icons.Glasses]: '61765',
  [Icons.GooglePay]: '61766',
  [Icons.Grape]: '61767',
  [Icons.GreenTick]: '61768',
  [Icons.HamburgerMenu]: '61769',
  [Icons.HandTruck]: '61770',
  [Icons.HeartSolid]: '61771',
  [Icons.Heart]: '61772',
  [Icons.HelpCircle]: '61773',
  [Icons.HidePassword]: '61774',
  [Icons.Home]: '61775',
  [Icons.HomepageCustomisation]: '61776',
  [Icons.InfoCircle]: '61777',
  [Icons.InformationCircle]: '61778',
  [Icons.Instagram]: '61779',
  [Icons.Kosher]: '61780',
  [Icons.LabelScanner]: '61781',
  [Icons.LastSoldBg]: '61782',
  [Icons.LigntningSolid]: '61783',
  [Icons.LinkedIn]: '61784',
  [Icons.LiveChat]: '61785',
  [Icons.LocationDotted]: '61786',
  [Icons.Location]: '61787',
  [Icons.Mastercard]: '61788',
  [Icons.Menu]: '61789',
  [Icons.Minus]: '61790',
  [Icons.MoneyBackApac]: '61791',
  [Icons.MoneyBackUs]: '61792',
  [Icons.MoneyBack]: '61793',
  [Icons.Mute]: '61794',
  [Icons.NoObligation]: '61795',
  [Icons.OffsetCarbon]: '61796',
  [Icons.Organic]: '61797',
  [Icons.PackagingPioneer]: '61798',
  [Icons.PadLockBenefits]: '61799',
  [Icons.Padlock]: '61800',
  [Icons.Pause]: '61801',
  [Icons.Paypal]: '61802',
  [Icons.PhoneArrow]: '61803',
  [Icons.PhoneSolid]: '61804',
  [Icons.Phone]: '61805',
  [Icons.Pioneer]: '61806',
  [Icons.Placeholder]: '61807',
  [Icons.PlayVideo]: '61808',
  [Icons.Play]: '61809',
  [Icons.Print]: '61810',
  [Icons.QuestionCircle]: '61811',
  [Icons.RadioSelected]: '61812',
  [Icons.Radio]: '61813',
  [Icons.RedAlertCircleFilled]: '61814',
  [Icons.RestaurantDishes]: '61815',
  [Icons.Rossette]: '61816',
  [Icons.SaleTagBenefits]: '61817',
  [Icons.SaleTag]: '61818',
  [Icons.Sale]: '61819',
  [Icons.SatisfactionGuarantee]: '61820',
  [Icons.Saving]: '61821',
  [Icons.Savings]: '61822',
  [Icons.Search]: '61823',
  [Icons.Share]: '61824',
  [Icons.Sort]: '61825',
  [Icons.StarSolid]: '61826',
  [Icons.Star]: '61827',
  [Icons.StwcBlog]: '61828',
  [Icons.SubscribeSave]: '61829',
  [Icons.Sustainable]: '61830',
  [Icons.Target]: '61831',
  [Icons.ThumbsDownSolid]: '61832',
  [Icons.ThumbsDown]: '61833',
  [Icons.ThumbsUpSolid]: '61834',
  [Icons.ThumbsUp]: '61835',
  [Icons.TickCircleSolid]: '61836',
  [Icons.TickCircle]: '61837',
  [Icons.Ticket]: '61838',
  [Icons.Trending]: '61839',
  [Icons.TruckBenefits]: '61840',
  [Icons.TruckSolid]: '61841',
  [Icons.Truck]: '61842',
  [Icons.Trust]: '61843',
  [Icons.Twitter]: '61844',
  [Icons.UnidentifiedCountry]: '61845',
  [Icons.Units]: '61846',
  [Icons.UnlimitedAvr]: '61847',
  [Icons.UnlimitedSale]: '61848',
  [Icons.UnlimitedSave]: '61849',
  [Icons.UnlimitedStwc]: '61850',
  [Icons.UnlimitedTruck]: '61851',
  [Icons.Unlimited]: '61852',
  [Icons.UnltCheckIcon]: '61853',
  [Icons.User]: '61854',
  [Icons.Vegan]: '61855',
  [Icons.Vegetarian]: '61856',
  [Icons.Views]: '61857',
  [Icons.Vinny]: '61858',
  [Icons.Visa]: '61859',
  [Icons.Warning]: '61860',
  [Icons.WineColour]: '61861',
  [Icons.WineGlass]: '61862',
  [Icons.World]: '61863',
  [Icons.XTwitter]: '61864',
  [Icons.Youtube]: '61865',
  [Icons.Zoom]: '61866',
};
